
    // this file was auto generated by python script
    import Power from './Power';
    export default Power;
    